import React, { useContext } from 'react';
import styles from './DatabaseOverviewWidget.module.css';
import ThemeContext from 'config/context/themeContext';
import { useCompositionsContext } from 'features/compositions/context/CompositionsContext';
import WidgetShell from '../WidgetShell';
import Loader from 'components/shared/loader/Loader';
import WidgetButton from 'components/shared/button/WidgetButton';
import { DatabaseIcon } from 'assets/icons';
import DatabaseScopesFetcher from 'features/compositions/data-fetchers/DatabaseScopesFetcher';

const DatabaseOverviewWidget = () => {
    const { dark } = useContext(ThemeContext);
    const { databaseStructure, databaseScopes, loading } = useCompositionsContext();
    
    // Calculate unique scopes count
    const uniqueScopesCount = databaseScopes ? new Set(databaseScopes.map(item => item.scope)).size : 0;
    const compositionsCount = databaseStructure?.compositions?.length || 0;
    return (
        <WidgetShell title={"Database Overview"} icon={<DatabaseIcon />}>
            <DatabaseScopesFetcher />
            {loading ? <Loader /> :
                <>
                    {compositionsCount ?
                        <div className={`${styles.database_overview} ${dark ? styles.dark : ""}`}>
                            <p>Compositions: <span>{compositionsCount}</span></p>
                            <p>Scopes: <span>{uniqueScopesCount}</span></p>
                        </div> :
                        <div className={`${styles.database_overview} ${dark ? styles.dark : ""}`}>
                            <p>You have not created any compositions yet!</p>
                        </div>
                    }

                    <WidgetButton href="/compositions/add-composition">
                        {compositionsCount ? "Create composition" : "Setup database"}
                    </WidgetButton>
                </>
            }
        </WidgetShell>
    );
}

export default DatabaseOverviewWidget;